(function($) {
    /**
     * @enum PolygonVertexType
     */
    class PolygonVertexType {
        static viewport  = new PolygonVertexType("viewport");
        static latlon    = new PolygonVertexType("latlon");
        static projected = new PolygonVertexType("projected");

        constructor(type) {
            this.type = type;
        }

        toString() {
            return type;
        }
    };

    $.PolygonVertexType = PolygonVertexType;
    
    /***
     * @class ABDOMap.PolygonVertex
     * @extends OpenSeadragon.Point
     */
    $.PolygonVertex = class extends OpenSeadragon.Point {
        /**
         * Constructor of ABDOMap.PolygonVertex
         * 
         * if type is latlon: x -> lat, y -> lon
         * @param {Number} x 
         * @param {Number} y 
         * @param {String} type 
         */
        constructor(x, y, type) { 
            super(x, y);
            
            switch(type) {
                case PolygonVertexType.viewport.type:
                case PolygonVertexType.viewport:
                    this.type = PolygonVertexType.viewport;
                    break;
                case PolygonVertexType.latlon.type:
                case PolygonVertexType.latlon:
                    this.type = PolygonVertexType.latlon;
                    break;
                case PolygonVertexType.projected.type:
                case PolygonVertexType.projected:
                    this.type = PolygonVertexType.projected;
                    break;
                default:
                    this.type = null;
            }
            
        }
    }; 
 

})(ABDOMap);
